import {useTranslation} from 'react-i18next';
import {useModal} from '@hooks';
import {ModalPage} from '@organisms';
import {ExtraService} from '@lib/store';
import {useExtraServices} from '@lib/logic';
import {nonEmpty} from '@lib/utils';
import {FlexCol, H3} from '@quarks';
import {ExtraServiceSelectionCell} from './ExtraServiceSelectionCell';
import {StyledSeparator} from './styles';

type Props = {
  category: ExtraService['category'];
  whitelistedBuidlings?: string[];
  onBack?: (() => void) | undefined;
  meetingId: string | undefined;
  selectedDate: string | undefined;
  locationName: string | undefined;
};

export const AllExtraServicesSelectionCard = ({
  category,
  whitelistedBuidlings,
  onBack,
  locationName,
  meetingId,
  selectedDate,
}: Props) => {
  const {t} = useTranslation('screen');
  const {closeModal} = useModal();

  const shouldUseWhitelisted = !!whitelistedBuidlings?.length;

  const {servicesByBuidlingId} = useExtraServices(category);

  const sections = nonEmpty(Object.values(servicesByBuidlingId));
  const whitelistedSections = shouldUseWhitelisted
    ? sections.filter((s) => whitelistedBuidlings.includes(s.buildingId))
    : sections;

  return (
    <ModalPage
      onClose={closeModal}
      title={t('AllExtraServices')}
      onBack={onBack}>
      <FlexCol gap={16}>
        {whitelistedSections.map((section) => (
          <FlexCol key={section.buildingId}>
            <H3 as="h2">{section.buildingName}</H3>

            <FlexCol style={{marginLeft: '8px'}}>
              {section.data.map((service) => (
                <div key={service.id}>
                  <ExtraServiceSelectionCell
                    service={service}
                    locationName={locationName}
                    meetingId={meetingId}
                    selectedDate={selectedDate}
                  />

                  <StyledSeparator />
                </div>
              ))}
            </FlexCol>
          </FlexCol>
        ))}
      </FlexCol>
    </ModalPage>
  );
};
